import AsoHeader from "../../../components/Aso/Header";
import AsoValidarDocumentosEmpresa from "../../../components/Aso/Register/AsoValidarDocumentosEmpresa";

const AsoRegistroValidarDocumentosEmpresa = () => {
    return (
        <>
            <AsoHeader />
            <AsoValidarDocumentosEmpresa />
        </>
    );
}

export default AsoRegistroValidarDocumentosEmpresa;